import NewsItem from '../newsItem/NewsItem';
import './NewsItems.css';
import { useEffect, useRef } from 'react';

let currentSum = 0;

function NewsItems(props) {

    function handleNewsItemReady(number) {
        currentSum += number;
        if (currentSum === props.sumNumbers) {
            currentSum = 0;
            window.scroll(0, 0);
        }
    }

    const currId = useRef(null);

    if (props.newsItems && props.page !== 0 && currId.current === null) {
        currId.current = props.newsItems[0].id;
    }

    useEffect(() => {
        if (props.newsItems) {
            if (currId.current !== props.newsItems[0].id) {
                currId.current = props.newsItems[0].id;
            }
        }
    }, [props.newsItems]);

    return (
        <>
            {props.newsItems && currId.current !== props.newsItems[0].id && props.newsItems.map((item, key) => (
                <div className="news-items__item" key={key}>
                    <NewsItem item={item} onReady={handleNewsItemReady} number={key+1} />
                </div>
            ))}
        </>
    );
}

export default NewsItems;